export const toastOptionsError = {
  autoClose: 6000,
  type: 'error',
  hideProgressBar: false,
  position: 'bottom-center',
  pauseOnHover: true,
  pauseOnFocusLoss: true,
  style: {
    backgroundColor: '#BF1616',
    fontFamily: 'Avenir Next for ABG',
    fontWeight: 500,
    color: '#f2f2f4',
  },
  draggable: true,
  draggablePercent: 100,
};

export const toastOptionsInfo = {
  autoClose: 6000,
  type: 'info',
  hideProgressBar: false,
  position: 'bottom-center',
  pauseOnHover: true,
  pauseOnFocusLoss: true,
  style: {
    backgroundColor: '#f48b00',
    fontFamily: 'Avenir Next for ABG',
    fontWeight: 600,
    color: '#000E1E',
    textAlign: 'center',
    fontSize: '16px',
  },
  draggable: true,
  draggablePercent: 100,
};

export const toastOptionsSuccess = {
  autoClose: 1500,
  delay: 0,
  type: 'success',
  hideProgressBar: true,
  position: 'bottom-center',
  pauseOnHover: true,
  pauseOnFocusLoss: true,
  style: {
    backgroundColor: '#fff',
    fontFamily: 'Avenir Next for ABG',
    fontWeight: 600,
    color: '#000E1E',
    textAlign: 'center',
    fontSize: '16px',
  },
  draggable: true,
  draggablePercent: 100,
};
